<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        class="text-center"
      >
        <div class="font-weight-light display-1">
          Select the integration you want to use
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        class="offset-3"
      >
        <v-text-field
          v-model="searchIntegration"
          append-icon="mdi-search"
          :label="'Integration name'"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="offset-3"
        cols="6"
      >
        <v-list
          flat
          subheader
        >
          <v-subheader>
            <span class="mr-5">Integration</span>
            <v-spacer />
            <span class="mr-5">Action</span>
          </v-subheader>
          <v-list-item-group>
            <template
              v-for="integration in filteredIntegrations"
            >
              <v-list-item
                :key="integration.id"
                @click="handleOpen(integration.id)"
              >
                <v-list-item-content>
                  <v-list-item-title class="d-inline-block">
                    <v-avatar
                      tile
                      left
                      size="35px"
                    >
                      <img
                        class="mt-2 d-inline-block"
                        :src="integration.logo"
                      >
                    </v-avatar>
                    <span class="ml-5">
                      {{ integration.name }}
                      <v-list-item-subtitle
                        class="ml-10 pl-5"
                        v-html="integration.description"
                      />
                    </span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    text
                  >
                    <v-icon left>
                      mdi-plus
                    </v-icon>
                    Configuration
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="'divider'+integration.id" />
            </template>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
    <v-dialog
      scrollable
      :value="dialog"
      persistent
      transition="dialog-bottom-transition"
      width="50%"
      @click:outside="handleClose"
    >
      <v-card class="pa-0">
        <v-toolbar
          dense
          tile
          flat
          color="grey lighten-5"
        >
          <v-toolbar-title v-if="selectedIntegration!=null">
            New Configuration
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              @click.native="handleClose"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <integration-config
            v-if="selectedIntegrationId!=null"
            v-model="newConfig"
            :integration="selectedIntegration"
            :project="project"
            @close="handleClose"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            depressed
            @click="handleClose"
          >
            Cancel
          </v-btn>
          <v-btn
            depressed
            @click="create"
          >
            Create Configuration
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import IntegrationConfig from './IntegrationConfig'
  import IntegrationService from './services/IntegrationService'
  export default {
    components: {
      IntegrationConfig,
    },
    props: {
      project: {
        type: Object,
        default: () => {
          return {
            name: null,
          }
        },
      },
    },
    data () {
      return {
        isInitiated: false,
        isLoading: false,

        // Context variables
        dialog: false,
        integrations: [],
        selectedIntegrationId: null,
        searchIntegration: '',
        newConfig: {},
      }
    },
    computed: {
      filteredIntegrations: function () {
        if (this.searchIntegration.length > 0) {
          return this.integrations.filter(integration => {
            return integration.name.toLowerCase().includes(this.searchIntegration.toLowerCase())
          })
        } else {
          return this.integrations
        }
      },
      selectedIntegration () {
        if (this.selectedIntegrationId != null) { return _.find(this.integrations, { id: this.selectedIntegrationId }) }
        return null
      },
    },
    mounted () {
      this.getIntegrations()
    },
    methods: {
      handleOpen (id) {
        const self = this
        self.selectedIntegrationId = null
        self.selectedIntegrationId = id
        _.delay(() => {
          self.dialog = true
        }, 100)
      },
      handleClose (nextToOpen) {
        const self = this
        self.dialog = false
        _.delay(() => {
          self.selectedIntegrationId = null
        }, 400)
      },
      create () {
        const self = this
        self.isLoading = true
        const conf = _.cloneDeep(self.newConfig)
        conf.project_id = this.$route.params.project
        IntegrationService.createConfiguration(conf, self).then(res => {
          self.$emit('create', res.data)
        }).finally(() => {
          self.isLoading = false
        })
      },
      getIntegrations () {
        const self = this
        self.isLoading = true
        IntegrationService.list(this, 0).then(function (response) {
          if (response.data.results.length) {
            self.integrations = response.data.results
          }
          self.loading = false
        }).catch(function (error) {
          self.$store.commit('push', { msg: error, color: 'error' })
          self.loading = false
        }).finally(() => {
          self.isLoading = false
          self.isInitiated = true
        })
      },
    },
  }
</script>
